<!-- Pipeline Mini -->
<div class="pipeline-mini">

  <!-- Stage 1: Manifest -->
  <span class="pipeline-dot"
    [class.completed]="isStageCompleted(1)"
    [class.active]="isStageActive(1)"
    [class.started]="hasStageStarted(1)"
    [class.clickable]="isClickable(1)"
    (click)="navigateTo(1)">
  </span>
  <span class="pipeline-label"
    [class.completed]="isStageCompleted(1)"
    [class.active]="isStageActive(1)"
    [class.started]="hasStageStarted(1)"
    [class.clickable]="isClickable(1)"
    [nz-tooltip]="isClickable(1) ? 'Go to Manifest' : 'Not started yet'"
    (click)="navigateTo(1)">Manifest</span>
  <span class="pipeline-arrow">→</span>

  <!-- Stage 2: Script -->
  <span class="pipeline-dot"
    [class.completed]="isStageCompleted(2)"
    [class.active]="isStageActive(2)"
    [class.started]="hasStageStarted(2)"
    [class.clickable]="isClickable(2)"
    (click)="navigateTo(2)">
  </span>
  <span class="pipeline-label"
    [class.completed]="isStageCompleted(2)"
    [class.active]="isStageActive(2)"
    [class.started]="hasStageStarted(2)"
    [class.clickable]="isClickable(2)"
    [nz-tooltip]="isClickable(2) ? 'Go to Script' : 'Not started yet'"
    (click)="navigateTo(2)">Script</span>
  <span class="pipeline-arrow">→</span>

  <!-- Stage 3: Moodboard -->
  <span class="pipeline-dot"
    [class.completed]="isStageCompleted(3)"
    [class.active]="isStageActive(3)"
    [class.started]="hasStageStarted(3)"
    [class.clickable]="isClickable(3)"
    (click)="navigateTo(3)">
  </span>
  <span class="pipeline-label"
    [class.completed]="isStageCompleted(3)"
    [class.active]="isStageActive(3)"
    [class.started]="hasStageStarted(3)"
    [class.clickable]="isClickable(3)"
    [nz-tooltip]="isClickable(3) ? 'Go to Moodboard' : 'Not started yet'"
    (click)="navigateTo(3)">Moodboard</span>
  <span class="pipeline-arrow">→</span>

  <!-- Stage 4: Storyboard -->
  <span class="pipeline-dot"
    [class.completed]="isStageCompleted(4)"
    [class.active]="isStageActive(4)"
    [class.started]="hasStageStarted(4)"
    [class.clickable]="isClickable(4)"
    (click)="navigateTo(4)">
  </span>
  <span class="pipeline-label"
    [class.completed]="isStageCompleted(4)"
    [class.active]="isStageActive(4)"
    [class.started]="hasStageStarted(4)"
    [class.clickable]="isClickable(4)"
    [nz-tooltip]="isClickable(4) ? 'Go to Storyboard' : 'Not started yet'"
    (click)="navigateTo(4)">Storyboard</span>
  <span class="pipeline-arrow">→</span>

  <!-- Stage 5: Video -->
  <span class="pipeline-dot"
    [class.completed]="isStageCompleted(5)"
    [class.active]="isStageActive(5)"
    [class.started]="hasStageStarted(5)"
    [class.clickable]="isClickable(5)"
    (click)="navigateTo(5)">
  </span>
  <span class="pipeline-label"
    [class.completed]="isStageCompleted(5)"
    [class.active]="isStageActive(5)"
    [class.started]="hasStageStarted(5)"
    [class.clickable]="isClickable(5)"
    [nz-tooltip]="isClickable(5) ? 'Go to Video' : 'Not started yet'"
    (click)="navigateTo(5)">Video</span>
  <span class="pipeline-arrow">→</span>

  <!-- Stage 6: Sound -->
  <span class="pipeline-dot"
    [class.completed]="isStageCompleted(6)"
    [class.active]="isStageActive(6)"
    [class.started]="hasStageStarted(6)"
    [class.clickable]="isClickable(6)"
    (click)="navigateTo(6)">
  </span>
  <span class="pipeline-label"
    [class.completed]="isStageCompleted(6)"
    [class.active]="isStageActive(6)"
    [class.started]="hasStageStarted(6)"
    [class.clickable]="isClickable(6)"
    [nz-tooltip]="isClickable(6) ? 'Go to Sound' : 'Not started yet'"
    (click)="navigateTo(6)">Sound</span>
    <span class="pipeline-arrow">→</span>

     <!-- Stage 6: Sound -->
  <span class="pipeline-dot"
    [class.completed]="isStageCompleted(7)"
    [class.active]="isStageActive(7)"
    [class.started]="hasStageStarted(7)"
    [class.clickable]="isClickable(7)"
    (click)="navigateTo(7)">
  </span>
  <span class="pipeline-label"
    [class.completed]="isStageCompleted(7)"
    [class.active]="isStageActive(7)"
    [class.started]="hasStageStarted(7)"
    [class.clickable]="isClickable(7)"
    [nz-tooltip]="isClickable(7) ? 'Go to Preview' : 'Not started yet'"
    (click)="navigateTo(7)">Preview</span>

</div>
